<template>
  <div v-html="rangeSliderElement"></div>
</template>

<script>
  import noUiSlider from 'nouislider/distribute/nouislider'
  export default {
    name: 'range-slider',
    props: {
      id: {
        type: String,
        required: true
      },
      minRange: {
        type: Number,
        required: true,
        default: 0
      },
      maxRange: {
        type: Number,
        required: true,
        default: 1
      },
      minValue: {
        type: Number,
        required: true,
        default: 0
      },
      maxValue: {
        type: Number,
        required: true,
        default: 1
      },
      step: {
        type: Number,
        required: false,
        default: 1
      },
      limit: {
        type: Object,
        default: null
      },
      allowSameValues: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      minRange (val) {
        this.updateMinMax()
      },
      maxRange (val) {
        this.updateMinMax()
      },
      minValue (val) {
        this.updateValues()
      },
      maxValue (val) {
        this.updateValues()
      },
      disabled (val) {
        this.toggle(val)
      },
      limit (limit) {
        let limitFrom = limit ? limit.from : null
        let limitTo = limit ? limit.to : null
        this.setLimit(limitFrom, limitTo)
      }
    },
    data () {
      return {
        rangeSlider: null,
        rangeSliderElement: `<div id="${this.id}"></div>`
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.rangeSlider = document.getElementById(this.id)
        if (this.rangeSlider && this.rangeSlider.noUiSlider) {
          this.rangeSlider.noUiSlider.destroy()
          let elem = document.getElementById(this.id)
          this.rangeSlider.parentNode.removeChild(elem)
          this.createElement()
        }
        this.create()
        this.onChangeSubscribe()
      },
      create () {
        this.rangeSlider = document.getElementById(this.id)
        let self = this
        noUiSlider.create(self.rangeSlider, {
          connect: true,
          step: self.step,
          start: [self.minValue ? self.minValue : self.minRange, self.maxValue ? self.maxValue : self.maxRange],
          limit: null,
          tooltips: [true, true],
          format: {
            // 'to' the formatted value. Receives a number.
            to: function (value) {
              return Math.round(value)
            },
            // 'from' the formatted value.
            // Receives a string, should return a number.
            from: function (value) {
              return Math.round(+value)
            }
          },
          range: {
            'min': [self.minRange],
            'max': [self.maxRange]
          }
        })
      },
      createElement () {
        this.rangeSliderElement = `<div id="${this.id}"></div>`
      },
      onChangeSubscribe () {
        let self = this
        this.rangeSlider.noUiSlider.on('change', function (values, handle, unencoded, tap, positions) {
          self.$emit('change', {
            from: values[0],
            to: values[1]
          })
        })
      },
      updateMinMax () {
        let self = this
        let minRangeValue = this.roundMinMax(this.minRange)
        let maxRangeValue = this.roundMinMax(this.maxRange)
        let rangeSlider = document.getElementById(self.id)
        if (rangeSlider.noUiSlider) {
          rangeSlider.noUiSlider.updateOptions({
            start: [self.minValue, self.maxValue],
            limit: self.maxValue / self.step === self.maxValue ? self.maxValue - self.minValue : null,
            range: {
              'min': minRangeValue,
              'max': maxRangeValue
            }
          })
        }
      },
      roundMinMax (num) {
        return Math.round(num / this.step) * this.step
      },
      updateValues () {
        let self = this
        let rangeSlider = document.getElementById(self.id)
        rangeSlider.noUiSlider.set([self.minValue, self.maxValue])
      },
      setLimit (from, to) {
        let self = this
        let limitValue = this.roundMinMax(to) - this.roundMinMax(from)
        // disabling slider if limitValue == 0 because limit option works with two sliders ONLY!
        // this.toggle(to && from && from === to)

        let rangeSlider = document.getElementById(self.id)
        rangeSlider.noUiSlider.updateOptions({
          limit: limitValue || null
        })
        rangeSlider.noUiSlider.set([self.minValue < from ? from : self.minValue, self.maxValue > to ? to : self
          .maxValue])
      },
      toggle (disabled) {
        if (disabled) {
          this.rangeSlider.setAttribute('disabled', true)
        } else {
          this.rangeSlider.removeAttribute('disabled')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// range-slider.vue?2308f6f6